import React from 'react'
import { connect } from 'react-redux';
import { setJiraIssue } from '../../state/actions/app'

const mapDispatchAsProps = dispatch => ({
	setJiraIssue: () => dispatch(setJiraIssue(null))
})
const mapStateAsProps = state => ({
	jiraState: state.jiraIssueState
})


class JiraIssue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ready: false
        }

    }

    createJiraIssueObject() {

        const jiraIssue = {
            summary: this.state.summary,
            priorityId: this.state.priority,
            extraFields: {},
            mappings: {
                uuid: this.props.jiraState.advice.id,
                cve: this.props.jiraState.advice.cve || null,
            }
        }
        const mappings = JSON.parse(this.props.jiraState.jiraInfo.projectMeta.mappings)
        for (const item of mappings) {
            if (item.key === "summary") continue
            if (item.key === "priority") continue
            jiraIssue.extraFields[item.key] = this.state[item.key]
        }

        return jiraIssue

    }

    async createJiraIssue (){
        try{
            const jiraIssue = this.createJiraIssueObject()
            await window.meterian.accounts.integrations.jira.projects.issues.create(this.props.accountInfo.uuid, this.props.jiraState.projectUuid, jiraIssue)
            window.$("#jira-issue-dialog").modal("hide")
            this.props.setJiraIssue()
            window.$("#loading").modal('show');
            await this.props.loadPage()
            setTimeout(()=>{
                window.$("#loading").modal('hide');
            }, 500)
            this.setState({ready: false})
            this.props.setAlertMessage("success", "Jira issue created successfully", 10000)
        }
        catch(e){
            this.setState({errorMessage: e.message})
        }
    }

    calculatePriorityDefaultValue(severity, options) {

        const severityAsNumber = window.severityToNumber(severity)
        const optionsCount = options.length
        const severitiesCount = 5
        const factor = optionsCount / severitiesCount
        return Math.round(severityAsNumber * factor)

    }
    mergeJiraInfoAndAdvice = (jiraInfo, advice) => {
        if(!jiraInfo?.projectMeta?.mappings) return []
        try{
            const mappings = JSON.parse(jiraInfo.projectMeta.mappings)
            for (const item of mappings) {
                item.value = null
                item.htmlElement = "input"
                if (item.key === "summary") {
                    if (advice.cve) item.value = advice.cve +" is affecting "+advice.library.name+":"+advice.version
                    else if (advice.cwe) item.value = "A vulnerability classified as "+advice.cwe+" is affecting "+advice.library.name+":"+advice.version
                    else item.value = "A "+advice.severity+" vulnerability is affecting "+advice.library.name+":"+advice.version
                }
    
                if (item.key === "description") {
                    item.value = advice.description
                    item.htmlElement = "textarea"
                }

                if (item.key === "priority") {
                    item.htmlElement = "select"
                    const valueIndex = this.calculatePriorityDefaultValue(advice.severity, item.allowedValues)
                    item.value = item.allowedValues[valueIndex].id
                    item.options = item.allowedValues.map(entry => {
                        return { value: entry.id, label: entry.name }
                    })
                    
                }
            }
            return mappings
        }
        catch(e){
            console.log(e)
            return []
        }
    }

    closeModal () {
        window.$("#jira-issue-dialog").modal("hide")
        this.props.setJiraIssue()
    }


    getSnapshotBeforeUpdate(prevProps, prevState) {
        return prevProps?.jiraState?.advice?.id !== this.props?.jiraState?.advice?.id
    }
    componentDidUpdate(_,__, didUpdate){

        if(!didUpdate) return
        const schema = this.mergeJiraInfoAndAdvice(this.props.jiraState.jiraInfo, this.props.jiraState.advice)
        const state = {}
        for (const item of schema) {
            state[item.key] = item.value
        }
        this.setState({schema, ...state, ready: true, errorMessage: null})
    }
    
    render(){
        if (!this.props.jiraState.ready || !this.state.ready) return null
        setTimeout(()=>{ window.$("#jira-issue-dialog").modal("show") })
        return (
            <div className="modal fade user-modal" id="jira-issue-dialog" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="jira-issue-title">Jira Issue</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.props.setJiraIssue()}><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            <form role="form">

                                {
                                    this.state.schema.map((item)=>{
                                        return <div className="form-group">
                                            <label htmlFor={"jira-"+item.key}>{item.name}:</label> 
                                            { item.htmlElement === "input" ? <input type="text" className="form-control" id={"jira-issue-"+item.key} placeholder={"Jira Issue "+item.key} defaultValue={item.value} onChange={(e) => this.setState({ [item.key]: e.target.value })} /> : null } 
                                            { item.htmlElement === "textarea" ? <textarea className="form-control" id={"jira-issue-"+item.key} placeholder={"Jira Issue "+item.key} defaultValue={item.value} onChange={(e) => this.setState({ [item.key]: e.target.value })} /> : null }
                                            { item.htmlElement === "select" ? <select className="form-control" id={"jira-issue-"+item.key} placeholder={"Jira Issue "+item.key} defaultValue={item.value} onChange={(e) => this.setState({ [item.key]: e.target.value })}>
                                                { item.options.map((option, index) => {
                                                    return <option key={index} value={option.value}>{option.label}</option>
                                                }) }
                                                </select> : null }
                                        </div>
                                    })
                                }
                                
                            </form>
                            {
                                this.state.errorMessage? 
                                    <div className="alert alert-danger" role="alert">
                                        {this.state.errorMessage}
                                    </div>
                                : null
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" data-dismiss="modal" onClick={() => this.props.setJiraIssue()}>Cancel</button>
                            <button type="button" className="btn btn-primary" id="jira-issue-submit" onClick={() => this.createJiraIssue() } >Save</button>
                        </div>
                    </div>
                </div>
            </div>  
        )

    }
}

export default connect(mapStateAsProps, mapDispatchAsProps)(JiraIssue);